import { jsx } from 'react/jsx-runtime';
import { parseUrlSafe } from '../../expandedResource.utils.js';
import { EmbedWrapper } from './EmbedWrapper.js';

const VimeoEmbed = ({ url, children }) => {
  const parsedUrl = parseUrlSafe(url);
  const videoId = parsedUrl?.pathname.split("/")[1];
  if (!videoId) {
    return children;
  }
  return /* @__PURE__ */ jsx(EmbedWrapper, {
    children: /* @__PURE__ */ jsx("iframe", {
      id: "vimeo-video-player",
      width: "100%",
      height: "315",
      src: `https://player.vimeo.com/video/${videoId}`,
      allowFullScreen: true
    })
  });
};

export { VimeoEmbed };
//# sourceMappingURL=VimeoEmbed.js.map
